import { ButtonsGroup } from '@billy/design-system'
import React, { ReactElement, useMemo } from 'react'
import { useLocation } from 'react-router'

import { ReportsType } from '@features/reports/enums/reportsType'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { REPORTS_IDS } from '../../constants/reportsRouteConfig'
import { getReportsRouteUrl } from '../../utils/getReportsToRouteUrl'
import { ExportReport } from '../ExportReport'

const routeToExportComponent: Record<ReportsType, () => JSX.Element> = {
  [ReportsType.ProfitAndLoss]: ExportReport.ProfitAndLoss,
  [ReportsType.TrialBalance]: ExportReport.TrialBalance,
  [ReportsType.BalanceSheet]: ExportReport.Balance,
}

export const ReportsSideActions = (): ReactElement => {
  const location = useLocation()
  const { organization } = useUserOrganization()

  const currentRoute = REPORTS_IDS.find((id) => getReportsRouteUrl(organization?.url, id) === location.pathname)

  const ExportReportComponent = useMemo(
    () => (currentRoute ? routeToExportComponent[currentRoute] : undefined),
    [currentRoute],
  )

  return <ButtonsGroup>{ExportReportComponent && <ExportReportComponent />}</ButtonsGroup>
}
